<main class="container mt-5">
  <div class="row justify-content-lg-center">
    <div class="col-lg-8">
      <div class="card rounded holder">
        <div class="card-body">
          <h4 class="text-dark mb-3">Forgot password?</h4>
          <ng-container *ngIf="!submitted">
            <form [formGroup]="recoveryForm" (ngSubmit)="onSubmitRecoveryForm()">
              <div class="form-group">
                <input class="form-control rounded-0"
                       type="text"
                       formControlName="usernameOrEmail"
                       [ngClass]="{'is-invalid': submitted && recoveryForm.controls.usernameOrEmail.errors}"
                       placeholder="Please enter your username or e-mail" aria-label="" autofocus/>
                <div class="invalid-feedback d-block" *ngIf="errorUsernameOrEmail">
                  {{errorUsernameOrEmail}}
                </div>
              </div>
              <button type="submit" class="btn btn-primary float-end d-inline-block">Next</button>
              <button type="button" class="btn btn-secondary float-end d-inline-block me-2" [routerLink]="['/']">
                Cancel
              </button>
            </form>
          </ng-container>
          <ng-container *ngIf="submitted">
            <alert type="success" class="mt-3">
              Thank you, you will receive an email containing a link to reset your password in a few seconds if your
              account exists.
            </alert>
            <button type="button" class="btn btn-secondary float-end d-inline-block" [routerLink]="['/']">Back to
              login
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</main>
